/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_States_TitleInputs */



/**
* | output |
* | --- |
* | "Board states" |
*
* @param {Board_States_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const board_states_title = /** @type {((inputs?: Board_States_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_States_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Board-Situationen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("États du plateau")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("牌局状态")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("牌局狀態")
	if (locale === "ko") return /** @type {LocalizedString} */ ("게임판 상태")
	return /** @type {LocalizedString} */ ("Board states")
});